import { createFileRoute } from "@tanstack/react-router";
import { AppDetailsPage } from "./installed-apps/-$appId/AppDetailsPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/apps_/installed/$appId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { appId, datasetSlug } = Route.useParams();
  useBreadCrumbs([
    { title: "Installed Apps", link: `/${datasetSlug}/apps/installed` },
    { title: "Details", link: `/${datasetSlug}/apps/installed/${appId}` },
  ]);
  return <AppDetailsPage />;
}
